define('application',["jquery", "angular"], function ($, angular) {
	"use strict";

	var app = {
		application: angular.module("App", [
			"app.controllers",
			"app.directives",
			"app.filters",
			"app.services"
		]),
		controllers: angular.module("app.controllers", []),
		directives: angular.module("app.directives", []),
		filters: angular.module("app.filters", []),
		services: angular.module("app.services", [])
	};

	app.application.run(["$rootScope", function ($rootScope) {}]);

	return app;

});
